import TochiShaderChunk from "./TochiShaderChunk";

export const DecalChunk: TochiShaderChunk = {
  name: "decal",
  uniforms: {
    decalMask: { value: null },
    decalColor: { value: null },
  },
  vertexShader: {},
  fragmentShader: {
    premain: `
        uniform sampler2D decalMask;
        uniform vec3 decalColor;
        `,
    main: `
        vec4 decalAlpha = texture2D(decalMask, vUv);
        vec4 decal = vec4(decalColor, 1.0);
        gl_FragColor = mix(gl_FragColor, max(decal, gl_FragColor), decalAlpha*gl_FragColor.a);
    `,
  },
};
